import data from './icf-category-de.json';
import { IcfCategory } from './model';

export interface IcfCategoryDetails {
  id: string;
  label: string;
  inclusion: string;
  exclusion: string;
}
export interface IcfCategories {
  [key: string]: IcfCategoryDetails;
}

export const icfCategoryDescriptions = data as IcfCategories;

export const icfCategoryLabels: { [key in IcfCategory]: string } = {
  b455: 'Funktionen der kardiorespiratorischen Belastbarkeit',
  b735: 'Funktionen des Muskeltonus',
  b750: 'Funktionen der motorischen Reflexe',
  b755: 'Funktionen der unwillkürlichen Bewegungsreaktionen',
  b760: 'Funktionen der Kontrolle von Willkürbewegungen',
  b770: 'Funktionen der Bewegungsmuster beim Gehen',
  d410: 'Eine elementare Körperposition wechseln',
  d420: 'Sich verlagern',
  d430: 'Gegenstände anheben und tragen',
  d440: 'Feinmotorischer Handgebrauch',
  d445: 'Hand- und Armgebrauch',
  d450: 'Gehen',
  d455: 'Sich auf andere Weise fortbewegen',
  d4103: 'Sich setzen und aufstehen',
  d4104: 'Stehende Position verändern ',
  d4105: 'Sich beugen',
  d4106: 'Seinen Körperschwerpunkt verlagern',
  d4153: 'In sitzender Position verbleiben',
  d4154: 'In stehender Position verbleiben',
  d4400: 'Einen Gegenstand aufheben',
  d4500: 'Kurze Entfernungen gehen',
  d4502: 'Gehen auf unterschiedlichen Unterlagen',
  d4551: 'Klettern / steigen',
  e340: 'Persönliche Hilfs- und Pflegepersonen',
};

export type AssessmentType = 'ARAT' | 'BBT' | 'ASECS' | 'NHPT' | 'BBS' | 'TS' | 'TUG' | 'FR' | 'MWT6' | 'FGA';
export type AssessmentSubType =
  | 'nhpt'
  | 'bbt'
  | 'bbs'
  | 'ts'
  | 'fr'
  | 'tug'
  | 'FGA'
  | 'mwt6'
  | 'grasp'
  | 'grip'
  | 'pinch'
  | 'gross';
